"use client";

import { useEffect, useState } from 'react';
import { loadPdfDocument } from '@/lib/pdf-editor/pdfLoader';
import PdfPage from './components/PdfPage';
import Toolbar from './components/Toolbar';
import { useEditorStore } from '@/lib/pdf-editor/store';
import { FileUploader } from "@/components/ui/FileUploader";
import { usePathname } from "next/navigation";
import { getLocaleFromPathname } from "@/lib/i18n";
import { getToolUiCopy } from "@/lib/tool-ui-copy";

// This would typically come from the route params or API
// For now, we mock it or allow upload if "new"
export default function EditorPage({ params }: { params: { id: string } }) {
  const [pdfDoc, setPdfDoc] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { setTotalPages } = useEditorStore();
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const ui = getToolUiCopy(locale);
  
  // Use a demo PDF if no file uploaded yet
  const pdfUrl = '/sample.pdf'; // We need a sample or upload mechanism

  useEffect(() => {
    // In a real app, fetch the URL based on params.id
    // If params.id is 'new', we might wait for upload context or similar
    // Here we load a placeholder/sample to demonstrate functionality
    
    // For this specific 'tools' user request, checking if we can get file from localStorage/Context
    // But basic load:
    if (params.id === 'demo') {
       // load demo
    }
  }, [params.id]);

  useEffect(() => {
    const handleUpload = async () => {
      // Logic to retrieve the uploaded file blob from previous page
      // For now, let's assume we have a way to get it, or fallback
      
      // Temporary: Create a simple PDF if none exists or use a fetch
    };
    handleUpload();
  }, []);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;
      
      const url = URL.createObjectURL(file);
      setLoading(true);
      try {
        const pdf = await loadPdfDocument(url);
        setPdfDoc(pdf);
        setTotalPages(pdf.numPages);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center pt-32 pb-20">
      <Toolbar />
      
      {!pdfDoc && (
        <div className="bg-white p-10 rounded-xl shadow-lg text-center w-full max-w-md">
          <FileUploader
            accept=".pdf,application/pdf"
            onFilesSelected={(files) => {
              if (files && files[0]) {
                const syntheticEvent = {
                  target: {
                    files: files,
                  }
                } as unknown as React.ChangeEvent<HTMLInputElement>;
                handleFileChange(syntheticEvent);
              }
            }}
            className="border-dashed border-2 border-violet-200 p-8"
          >
             <h2 className="text-2xl font-bold mb-4">{ui.uploadPdfToEdit}</h2>
             <div className="text-violet-500 font-medium">{ui.clickToSelectOrDragPdfHere}</div>
          </FileUploader>
        </div>
      )}

      {pdfDoc && (
        <div className="flex flex-col items-center gap-4">
          {Array.from({ length: pdfDoc.numPages }, (_, i) => (
            <PdfPage 
              key={i + 1} 
              pdfDoc={pdfDoc} 
              pageNumber={i + 1} 
            />
          ))}
        </div>
      )}
    </div>
  );
}
